class ResponsiveTablesLight {
  constructor(config = {}) {
    const {
      tableComponentSelector,
      tableContainerSelector,
      tableSelector
    } = config;

    this.tables = document.querySelectorAll(tableSelector);
    this.tablesArray = Array.prototype.slice.call(this.tables);

    if (this.tables) {
      this.tablesArray.forEach(table => {
        let container = table.closest(tableContainerSelector);
        let component = table.closest(tableComponentSelector);

        this.toggleResponsiveTableClasses(component, container, table);
      });
    }
  }


  toggleResponsiveTableClasses(component, container, table) {
    const griIndexTable = container.closest('[data-tableid="GRI_Index"]');
    const isDesktop = window.innerWidth >= 1024;

    if (griIndexTable && isDesktop) {
      component.classList.remove('has-shadow', 'responsive-table');
      return;
    }

    if (this.hasHorizontalScrollbar(container, table) === true) {
      component.classList.add('has-shadow', 'responsive-table');
    } else {
      component.classList.remove('has-shadow', 'responsive-table');
    }

    window.addEventListener('resize', () => {
      const isDesktopNow = window.innerWidth >= 1024;

      if (griIndexTable && isDesktopNow) {
        component.classList.remove('has-shadow', 'responsive-table');
        return;
      }

      if (this.hasHorizontalScrollbar(container, table) === true) {
        component.classList.add('has-shadow', 'responsive-table');
      } else {
        component.classList.remove('has-shadow', 'responsive-table');
      }
    });
  }

  hasHorizontalScrollbar(container, table) {

    const containerWidth = container.clientWidth;
    const tableWidth = table.clientWidth;

    // console.log('container-width:', containerWidth)
    // console.log('table-width:', tableWidth, table)

    return tableWidth > containerWidth;
  }
}

export default ResponsiveTablesLight;
